import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Store } from '@ngrx/store';
import { distinctUntilChanged, filter, Observable, Subject, takeUntil } from 'rxjs';
import { AppState } from 'src/app/core/app.state';
import { IAgent } from 'src/app/features/agents/models/agents.models';
import { ICommission } from 'src/app/features/agents/models/commissions.models';

@Component({
  selector: 'app-commission-agents',
  templateUrl: './commission-agents.component.html',
  styleUrls: ['./commission-agents.component.scss']
})
export class CommissionAgentsComponent implements OnInit {
  @Input() commission!: ICommission;

  commissionAgents: IAgent[] = [];

  agents$: Observable<IAgent[]> = this.store.select((state: AppState) => state.agents.agents);

  agentsList: IAgent[] = [];
  agents: IAgent[] = [];
  filteredAgents: IAgent[] = [];
  selectedAgents: number[] = [];
  searchInput = new FormControl('');

  assignView: boolean = false;

  destroy$ = new Subject<void>();

  constructor(private store: Store<AppState>) { }

  ngOnInit(): void {
    this.commissionAgents = this.commission.agents as IAgent[];
    this.agents = this.commissionAgents;
    this.filteredAgents = this.agents;

    this.agents$
    .pipe(
      takeUntil(this.destroy$)
    )
    .subscribe((agents: IAgent[]) => {
      this.agentsList = agents;
    });
  }

  search(event: any) {
    const key = event.target.value.toLowerCase();

    if (key != '') {
      this.filteredAgents = this.agents.filter((agent) => `${agent.first_name} ${agent.last_name}`.toLowerCase().includes(key));
    } else {
      this.filteredAgents = this.agents;
    }
  }

  isAllAgentsSelected(): boolean {
    const allAgentIds = this.filteredAgents.map((agent: IAgent) => agent.id);
    return allAgentIds.length ? allAgentIds.every((id: any) => this.selectedAgents.includes(id)) : false;
  }

  isPartialSelectedAll(): boolean {
    const allAgentIds = this.filteredAgents.map((agent: IAgent) => agent.id);
    const selectedCount = allAgentIds.filter((id: any) => this.selectedAgents.includes(id)).length;
    return selectedCount > 0 && selectedCount < allAgentIds.length;
  }

  toggleAllAgents(checked: boolean) {
    const allIds = this.filteredAgents.map((l: IAgent) => l.id!);
    this.selectedAgents = checked ? [...allIds] : [];
  }

  toggleAgent(agentId: number, checked: boolean) {
    if (checked) {
      this.selectedAgents.push(agentId);
    } else {
      this.selectedAgents = this.selectedAgents.filter((id) => id !== agentId);
    }
  }

  trackByAgentId(_index: number, agent: IAgent): string | number {
    return agent.id!;
  }

  assignMore() {
    this.clear();

    const commissionAgentIds = this.commissionAgents.map(agent => agent.id);
    this.agents = this.agentsList.filter(agent => !commissionAgentIds.includes(agent.id));
    this.filteredAgents = [...this.agents];
    this.assignView = true;
  }

  cancelAssignMore() {
    this.clear();

    this.agents = this.commissionAgents;
    this.filteredAgents = this.agents;
    this.assignView = false;
  }

  assign() {
    const selectedAgents = this.agentsList.filter(agent => this.selectedAgents.includes(agent.id!)) as IAgent[];

    this.commissionAgents = [...this.commissionAgents, ...selectedAgents];

    this.cancelAssignMore();
  }

  removeSelectedAgents() {
    this.commissionAgents = this.agents.filter(agent => !this.selectedAgents.includes(agent.id!));
    this.agents = this.commissionAgents;
    this.filteredAgents = this.agents;
    this.selectedAgents = [];
  }

  clear() {
    this.searchInput.setValue('');
    this.selectedAgents = [];
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
